import imgvocehome from '../../assets/images/img-home-PF.png';
import { Link } from 'react-router-dom';
import useScreenSize from '../../hooks/useScreenSize';
import { useEffect, useState } from 'react';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';

const produtos = [
    (<div className='info-container blue'>
        <div>
            <h1>Recebimentos de salários</h1>
            <h2>
            Trabalhar para uma empresa estrangeira
            pode ser uma experiência incrível!
            Aprender com diferentes culturas,
            ampliar meus horizontes e desenvolver
            habilidades globais é um privilégio.
            Conte com a Cobalt para recebimentos.
            </h2>
            <Link className='info-button' to={"/produtos-para-voce"} state={{tab: 1}}> Ver produtos </Link>
        </div>
    </div>),
    (
        <div className='info-container d_blue'>
                    <div>
                        <h1>Câmbio para viagens</h1>
                        <h2>
                            Planejar o câmbio para sua viagem
                            internacional é essencial! Antecedência é
                            a chave para garantir as melhores taxas e
                            evitar imprevistos. Na Cobalt somos
                            transparentes, sem taxas escondidas, as
                            melhores cotações para você.
                        </h2>
                        <Link className='info-button' to={"/produtos-para-voce"} state={{tab: 2}}> Ver produtos </Link>
                    </div>
                </div>
    ),
    (
        <div className='info-container d_blue'>
                    <div>
                        <h1>Intercâmbio</h1>
                        <h2>
                            Aprender um novo idioma, conhecer
                            pessoas do mundo todo e explorar
                            lugares incríveis... o intercâmbio é uma
                            experiência transformadora! A Cobalt te
                            ajuda com as transferências de recursos
                            financeiros.
                        </h2>
                        <Link className='info-button' to={"/produtos-para-voce"} state={{tab: 3}}> Ver produtos </Link>
                    </div>
                </div>
    ),
    (
        <div className='info-container blue'>
                    <div>
                        <h1>Múltiplas cotações</h1>
                        <h2>
                            A Cobalt possui muitos players liquidantes,
                            desde os grandes bancos até os bancos de nicho
                            cambial. No dia a dia, o nosso trader fará as
                            cotações em todos os players, em tempo real,
                            garantindo as melhores ofertas condições do
                            mercado financeiro.
                        </h2>
                        <a href='https://wa.me/5511973667387' target="_blank" rel="noopener noreferrer" className='info-button'> Fale com um especialista </a>
                    </div>
                </div>
    )
]

export const ParaVoce = () => {
    const size = useScreenSize();
    const [swipeLayout, setSwipeLayout] = useState(false)

    useEffect(() => {
        setSwipeLayout(size.width < 900)
    },[size])

    return (

        <div className='container-page4' style={{backgroundColor: "#2242d4"}}>

        <div className={`container-1-page4 ${swipeLayout? "voceBG" : ""}`} >
            <h1> [ Para você ] </h1>
            <h2> Não é só uma operação de câmbio: </h2>
            <p>
                Oferecemos o que os outros oferecem, mas com eficiência, agilidade e personalização.
                Possuímos uma plataforma conectada à múltiplos players, possibilitando que você
                consiga as melhores condições e taxas do mercado para enviar ou receber uma remessa.
            </p>
        </div>

        <div className='container-2-page4'>
        {swipeLayout? 
                     <Swiper
        
                     modules={[Pagination, Autoplay]}
                     autoplay={{ delay: 4500 }}
                     pagination
                     loop
                 >
                     {produtos.map(slides => (
                         <SwiperSlide>
                            <div className='info-column'>
                                {slides}
                            </div>
                         </SwiperSlide>
                     ))}
        
                    </Swiper>
                    :
        
                        <>
                         <div className='info-column'>
            {produtos[0]}
            {produtos[1]}
            </div>
            <div className='info-image'>
                <img src={imgvocehome} alt="Você" />
            </div>
            <div className='info-column'>
            {produtos[2]}
            {produtos[3]}
            </div>
            </>
        }
        
           

        

        </div>

    </div>


    )

}
